const API_URL = 'https://marina.carreticacuentera.com/info';
const MEDIA_URL = 'https://marina.carreticacuentera.com';
const PAGES = '/paginas' ;
const BOOKS = '/libros';

export { API_URL, MEDIA_URL, PAGES, BOOKS };